import React from 'react';
import type { PixQrCodeSectionProps } from '../types/pix-payment.types';

const PixQrCodeSection: React.FC<PixQrCodeSectionProps> = ({ qrCode }) => {
  // Se não houver qrCode ainda, exibe placeholder seguro
  const hasQr = typeof qrCode === 'string' && qrCode.trim().length > 0;
  const qrCodeSrc = hasQr
    ? (qrCode.startsWith('data:image/png;base64,') ? qrCode : `data:image/png;base64,${qrCode}`)
    : '';

  return (
    <div className="hidden lg:w-1/2 lg:flex flex-col items-center mb-6 lg:mb-0 mr-0">
      <div className="p-4 border border-medium-gray dark:border-gray-600 rounded-lg inline-block bg-gray-50 dark:bg-gray-700 w-60 h-60 flex items-center justify-center">
        {hasQr ? (
          <img
            src={qrCodeSrc}
            alt="PIX QR Code"
            className="w-48 h-48 sm:w-60 sm:h-60 object-contain"
            aria-label="QR Code para pagamento PIX"
          />
        ) : (
          <div className="flex flex-col items-center justify-center text-center">
            <div className="w-12 h-12 border-4 border-gray-300 border-t-primary rounded-full animate-spin mb-3" aria-label="Carregando"></div>
            <span className="text-sm text-text-secondary dark:text-gray-300">Gerando QR Code...</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default PixQrCodeSection; 